const InterviewQuestions = {
    Household: {
        index: 1
    },
    Bathrooms: {
        index: 2
    },
    TrashPreferences: {
        index: 3
    },
    Cooking: {
        index: 4
    },
    DishwashingFrequency: {
        index: 5
    },
    Cleaning: {
        index: 6
    },
    LaundryFrequency: {
        index: 7
    },
    TierPreferences: {
        index: 8
    },
    Prediction: {
        index: 9
    }
}

export default InterviewQuestions;
